import React, { Component } from "react";
import { Field, withFormik } from "formik";
import { compose } from "redux";
import { bool, string, func, oneOf, shape, arrayOf, node } from "prop-types";
import { replace, goBack } from "connected-react-router";
import moment from "moment";
import { routerActions } from "connected-react-router";

import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import { actions as formActions } from "reducers/form";
import { actions as templateActions } from "reducers/template";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";
import * as stringUtils from "util/string";
import { Mixpanel } from "util/clickstreaming";

import FormActions from "pages/forms/_components/FormActions";
import Scheduler from "pages/forms/_components/_fields/Scheduler";
import mapProps from "pages/_components/mapProps";
import CreateTemplateModal from "pages/forms/_components/CreateTemplateModal";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";
import Head from "pages/_components/Head";
import TransactionTicket from "pages/forms/_components/TransactionTicket";
import Container from "pages/_components/Container";
import TemplateList from "pages/forms/_components/TemplateList";
import TicketHead from "pages/_components/TicketHead";
import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import { actions as transactionActions } from "reducers/transactions";
import { actions as bankActions } from "reducers/bankSelector";
import FormConfirmation from "./FormConfirmation";
import OpeningAccountStep2 from "./_regulations/OpeningAccountStep2";

class FormRenderCustom extends Component {
    static propTypes = {
        values: shape({}).isRequired,
        dispatch: func.isRequired,
        isSubmitting: bool.isRequired,
        currentLang: string.isRequired,
        metadata: shape({}).isRequired,
        errors: shape({}).isRequired,
        handleSubmit: func.isRequired,
        mode: oneOf(["view", "edit", "edit-step2", "preview"]),
        // tells if the form is being rendered from Backoffice
        fromBackoffice: bool,
        // tells if the form is being rendered to confirm a recently made transaction
        ticketConfirmation: bool,
        title: string,
        templates: arrayOf(shape()),
        history: shape({ location: shape({ pathname: string }) }).isRequired,
        match: shape({ path: string, url: string, isExact: bool }).isRequired,
        setValues: func.isRequired,
        setErrors: func.isRequired,
        setFieldValue: func.isRequired,
        isMobile: bool,
        isDesktop: bool.isRequired,
        fetching: bool,
        location: shape({ pathname: string }).isRequired,
        id: string,
        childrenTransactions: shape({}),
        parentTransaction: shape({}),
        transaction: shape({
            idTransaction: string.isRequired,
        }).isRequired,
        renderFields: func.isRequired,
        idActivity: string.isRequired,
        renderAdditionalActions: func,
        renderFootNote: node,
        showSubmit: bool,
        titleConfirmation: bool,
        renderFieldsTermsAndConditions: func,
        returnBack: bool,
        titleFormConfirmation: string,
        closeLinkTo: string,
    };

    static defaultProps = {
        mode: "edit",
        fromBackoffice: false,
        ticketConfirmation: false,
        title: "",
        templates: [],
        isMobile: false,
        fetching: false,
        id: null,
        childrenTransactions: null,
        parentTransaction: null,
        renderAdditionalActions: null,
        renderFootNote: null,
        showSubmit: true,
        titleConfirmation: false,
        renderFieldsTermsAndConditions: null,
        returnBack: false,
        titleFormConfirmation: "",
        closeLinkTo: null,
    };

    componentDidMount() {
        this.loadTemplateList();
    }

    componentDidUpdate(prevProps) {
        const { idActivity } = this.props;
        if (idActivity !== prevProps.idActivity) {
            this.loadTemplateList();
        }
    }

    componentWillUnmount() {
        const { dispatch, history, match } = this.props;
        const { pathname } = history.location;
        const { url } = match.url;

        if (!pathname.includes(url)) {
            dispatch(formActions.formClosed());
        }
        const data = {};
        if (!pathname.includes("bankSearch")) {
            dispatch(formActions.setData(data));
            dispatch(bankActions.resetSelectedBanks());
        }
    }

    loadTemplateList = () => {
        const {
            metadata: { templatesEnabled },
            mode,
            dispatch,
            idActivity,
            fromBackoffice,
        } = this.props;
        const isTemplatesVisibile = mode === "edit" && templatesEnabled && !fromBackoffice;
        if (isTemplatesVisibile) {
            const idActivityTemplate = idActivity.replace(".pre", ".send");
            dispatch(templateActions.loadTemplateList(null, idActivityTemplate));
        }
    };

    handleClick = (action) => {
        const {
            dispatch,
            metadata: { idForm, idActivity },
            transaction,
            values,
        } = this.props;

        const { idTransaction } = transaction;

        Mixpanel.track_form(idForm, {
            action,
            idActivity,
            ...values,
        });
        switch (action) {
            case "createTemplate":
                dispatch(templateActions.createTemplate());
                this.loadTemplateList();
                break;
            case "saveDraft":
                dispatch(
                    formActions.saveDraft({
                        idActivityDraft: idActivity,
                        data: values,
                        idTransaction: transaction ? idTransaction : null,
                    }),
                );
                break;
            case "cancelTransaction":
                dispatch(formActions.cancelTransactionPre({ idActivity, idForm }));
                break;
            case "modifyTransaction":
                dispatch(formActions.changeCancelTransaction(false));

                dispatch(formActions.modifyTransaction(idTransaction));
                break;
            case "signTransaction":
                dispatch(
                    formActions.signTransactionPreview({
                        idForm,
                        idActivity,
                        idTransaction: transaction.idTransaction,
                        ticketData: {}, // Requerido en administrationTicket.signAdministrativeTransaction
                    }),
                );
                break;
            case "downloadTicketPdf":
                dispatch(formActions.downloadTicket(idTransaction, "pdf", idForm));
                break;
            case "shareTicket":
                dispatch(formActions.shareTicket(idTransaction, "pdf", idForm));
                break;
            default:
                break;
        }
    };

    renderScheduler = () => {
        const {
            currentLang,
            metadata: {
                enabledWeekDays,
                firstWorkingDate,
                maxDaysToSchedule,
                nonWorkingDays,
                programable,
                schedulable,
            },
            mode,
        } = this.props;

        const data = {
            enabledWeekDays,
            firstWorkingDate,
            maxDaysToSchedule,
            nonWorkingDays,
            lang: currentLang,
            mode,
            programable,
            schedulable,
        };

        return <Field component={Scheduler} data={data} name="scheduler" />;
    };

    openTemplateScreen = () => {
        const { dispatch, match, values } = this.props;

        dispatch(routerActions.push(`${match.url}/templates`, { shouldLoadForm: true }));
        dispatch(formActions.setData(values));
    };

    handleClose = () => {
        const { dispatch, location, closeLinkTo } = this.props;
        let pathname = closeLinkTo || "/desktop";
        if (location.pathname.match("/transaction/")) {
            pathname = "/transactions/list";
            dispatch(transactionActions.setFilters(null));
        }
        dispatch(replace({ pathname, state: { transition: "transition-flow-close" } }));
    };

    handleBack = () => {
        const { dispatch, mode, returnBack, location } = this.props;
        const isTicketRendered = location.pathname.match("/transaction/") != null;

        const pathname = isTicketRendered ? "/transactions/list" : "/desktop";
        if (mode === "preview") {
            dispatch(formActions.goBackCleanTransaction());
        } else if (returnBack) {
            dispatch(goBack());
        } else {
            dispatch(replace({ pathname, state: { transition: "transition-flow-close" } }));
        }
    };

    handleTemplateSelect = (template) => {
        const { setValues, setErrors, dispatch, metadata } = this.props;
        const templateToBeLoaded = template;
        const { onTemplateLoad } = metadata;

        if (templateToBeLoaded?.scheduler?.valueDate) {
            const valueDate = moment(templateToBeLoaded.scheduler.valueDate);
            templateToBeLoaded.scheduler.valueDate = valueDate;
        }

        setValues(templateToBeLoaded);
        setErrors({});
        dispatch(transactionLinesActions.loadTransactionLinesTemplateData(template));
        if (onTemplateLoad) {
            onTemplateLoad(templateToBeLoaded);
        }
    };

    renderFieldsSection = () => {
        const {
            metadata: { programable, schedulable, templatesEnabled },
            mode,
            isDesktop,
            templates,
            renderFields,
            setFieldValue,
            values,
            setValues,
        } = this.props;
        const isTemplatesVisibile = mode === "edit" && templatesEnabled && templates.length > 0;

        const viewColProperties = mode === "view" ? { lg: 6, lgOffset: 3 } : {};

        return (
            <Row className="form-content justify-content-center">
                <Col sm={12} md={mode === "view" ? 6 : 8} mdOffset={isTemplatesVisibile ? 0 : 2} {...viewColProperties}>
                    {!isDesktop && isTemplatesVisibile && (
                        <Button
                            className="btn-ico"
                            onClick={this.openTemplateScreen}
                            label="forms.templates.load"
                            image="images/draft.svg"
                        />
                    )}
                    {renderFields(setFieldValue, values, setValues)}
                    {(programable || schedulable) && this.renderScheduler()}
                </Col>
                {isDesktop && isTemplatesVisibile && (
                    <Col sm={12} md={4}>
                        <I18n component="h4" componentProps={{ className: "control-label" }} id="forms.templates" />
                        <Container.ColumnBody>
                            <TemplateList onSelect={this.handleTemplateSelect} className="navigational-list" />
                        </Container.ColumnBody>
                    </Col>
                )}
            </Row>
        );
    };

    renderFormContent = () => {
        const {
            mode,
            transaction,
            childrenTransactions,
            parentTransaction,
            fromBackoffice,
            ticketConfirmation,
            isSubmitting,
            isDesktop,
            templates,
            metadata: { draftsEnabled, templatesEnabled, idForm, showSubmit },
            renderAdditionalActions,
            renderFootNote,
        } = this.props;

        const isTemplatesVisibile = mode === "edit" && templatesEnabled && templates.length > 0;

        const isEditable =
            typeof childrenTransactions === "undefined" ||
            childrenTransactions === null ||
            childrenTransactions.length === 0;

        const actionButtons = !fromBackoffice && (
            <FormActions
                onClick={this.handleClick}
                fetching={isSubmitting}
                mode={mode}
                draftsEnabled={draftsEnabled}
                templatesEnabled={templatesEnabled}
                transaction={transaction}
                isEditable={isEditable}
                idForm={idForm}
                isDesktop={isDesktop}
                additionalActions={renderAdditionalActions}
                showSubmit={showSubmit}
                renderFootNote={renderFootNote}
                isTemplatesVisibile={isTemplatesVisibile}
            />
        );

        if (mode === "edit") {
            return (
                <>
                    {this.renderFieldsSection()}
                    {actionButtons}
                </>
            );
        }

        return (
            <TransactionTicket
                childrenTransactions={childrenTransactions}
                formActions={actionButtons}
                fromBackoffice={fromBackoffice}
                parentTransaction={parentTransaction}
                ticketConfirmation={ticketConfirmation}
                transaction={transaction}>
                {this.renderFieldsSection()}
            </TransactionTicket>
        );
    };

    renderContent = () => {
        const {
            mode,
            values,
            id,
            metadata,
            currentLang,
            handleSubmit,
            setFieldValue,
            renderFields,
            titleConfirmation,
            renderFieldsTermsAndConditions,
            titleFormConfirmation,
        } = this.props;
        const { idActivity } = metadata;
        const isOverdraftFlow = false;
        switch (mode) {
            case "edit":
                return (
                    <>
                        <form className="above-the-fold" onSubmit={handleSubmit}>
                            {this.renderFormContent()}
                        </form>
                        <CreateTemplateModal values={values} idForm={id} idActivityTemplate={idActivity} />
                    </>
                );
            case "view":
                return (
                    <>
                        <div className="above-the-fold">{this.renderFormContent()}</div>
                    </>
                );
            case "edit-step2":
                if (isOverdraftFlow) {
                    return (
                        <OpeningAccountStep2
                            overdraft={values.overdraft}
                            accountType={values.accountType}
                            setFieldValue={setFieldValue}
                        />
                    );
                }
                return <></>;
            case "preview":
                return (
                    <FormConfirmation
                        idForm={id}
                        metadata={metadata}
                        currentLang={currentLang}
                        renderFields={() =>
                            renderFields(
                                () => {},
                                values,
                                () => {},
                            )
                        }
                        titleConfirmation={titleConfirmation}
                        renderFieldsTermsAndConditions={renderFieldsTermsAndConditions}
                        titleFormConfirmation={titleFormConfirmation}
                    />
                );

            default:
                return <></>;
        }
    };

    renderHeader = () => {
        const { mode, fromBackoffice, location, isMobile, title } = this.props;
        const isTicket = location.pathname.match("/transaction/") != null;

        if (!fromBackoffice) {
            if (mode !== "view" && mode !== "edit") {
                return (
                    <>
                        {isMobile ? (
                            <Head
                                showLogo
                                className="blue-main-header-mobile"
                                onBack={() => this.handleBack(isTicket)}
                                arrowWhite
                            />
                        ) : (
                            <Head
                                hideMenu
                                accessibilityTextId="administration.forms.confirm.credentials"
                                titleText={i18n.get(title)}
                                onBack={this.handleBack}
                            />
                        )}
                    </>
                );
            }

            if (isTicket || (isMobile && mode === "view")) {
                return (
                    <TicketHead
                        accessibilityTextId="administration.forms.transaction.details"
                        onClose={this.handleClose}
                        titleText={i18n.get(title)}
                        handleClick={this.handleClick}
                    />
                );
            }

            return (
                <Head
                    onClose={this.handleClose}
                    titleText={i18n.get(title)}
                    hideMenu
                    accessibilityTextId={isTicket || (mode === "view" && "administration.forms.transaction.details")}
                />
            );
        }
        return null;
    };

    render() {
        const { fetching, currentLang, errors, isMobile } = this.props;
        return (
            <>
                <Notification scopeToShow="form" errors={errors} currentLang={currentLang} />
                {!fetching && this.renderHeader()}

                <MainContainer showLoader={fetching}>
                    <div className={isMobile ? "container-fluid " : "container "}>
                        {!fetching && this.renderContent()}
                    </div>
                </MainContainer>
            </>
        );
    }
}

export default compose(
    withFormik({
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: ({ data }) => ({
            ...data,
            scheduler: data?.scheduler
                ? {
                      ...data.scheduler,
                      valueDate: data.scheduler.valueDate ? moment(data.scheduler.valueDate) : null,
                  }
                : null,
        }),
        handleSubmit: (values, formikBag) => {
            const focusedField = document.activeElement;
            if (focusedField) {
                focusedField.blur();
            }

            const filteredValues = Object.entries(values).reduce((accumulator, [key, value]) => {
                if (value === "") {
                    return accumulator;
                }
                if (Array.isArray(value) && value.length > 0 && value[0].text !== undefined) {
                    const arrayValues = [];
                    value.forEach((item) => {
                        arrayValues.push(item.text || item);
                    });
                    return {
                        ...accumulator,
                        [key]: arrayValues,
                    };
                }
                return {
                    ...accumulator,
                    [key]: stringUtils.trim(value),
                };
            }, {});

            Mixpanel.track_form(formikBag.props.id, filteredValues);

            if (formikBag.props.useDefaultSubmit) {
                formikBag.props.dispatch(
                    formActions.previewForm({
                        formikBag,
                        idActivity: formikBag.props.metadata.idActivity,
                        idTransaction: formikBag.props.transaction ? formikBag.props.transaction.idTransaction : null,
                        values: filteredValues,
                    }),
                );
            } else {
                formikBag.props.dispatch(formikBag.props.alternateSubmitFunc({ formikBag, values: filteredValues }));
            }
        },
    }),
    mapProps(({ metadata, ...props }) => ({
        ...props,
        metadata,
    })),
)(FormRenderCustom);
